import { render } from "./associationAdministrator.vue?vue&type=template&id=d3c54d18&scoped=true"
import script from "./associationAdministrator.vue?vue&type=script&lang=js"
export * from "./associationAdministrator.vue?vue&type=script&lang=js"

import "./associationAdministrator.vue?vue&type=style&index=0&id=d3c54d18&lang=scss&scoped=true"
import "./associationAdministrator.vue?vue&type=style&index=1&id=d3c54d18&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c54d18"]])

export default __exports__